import React from "react";

const elementCache = {};
window.AudioContext = window.AudioContext || window.webkitAudioContext;
const audioContext = new AudioContext();

class NnAudioElement extends React.Component {
  constructor(props) {
    super(props);
    this.srcfolder = props.srcfolder;
    this.octave = props.octave;
    this.note = props.note;
    this.src = `${this.srcfolder}/0${this.octave}_${this.note}.mp3`
    elementCache[this.cacheKey] = this;
  }

  render() {
    return null;
  }

  componentDidMount() {
    this.load();
  }

  get cacheKey() {
    return NnAudioElement.getCacheKey(this.octave, this.note);
  }
  static getCacheKey(octave, note) {
    return `${octave}_${note}`;
  }
  getAudioElement() {
    return elementCache[this.cacheKey].ele;
  }
  static getAudioElement(octave, note) {
    let k = NnAudioElement.getCacheKey(octave, note);
    let e = elementCache[k];
    return e;
  }

  load() {
    return fetch(this.src, {responseType: 'arraybuffer'})
    .then(response => response.arrayBuffer())
    .then(arrayBuffer => audioContext.decodeAudioData(arrayBuffer, (buffer) => this.buffer = buffer))
    .catch(error => console.log(`error: ${error}`))
  }

  play() {
    let source = audioContext.createBufferSource();
    let amplifier = audioContext.createGain();
    amplifier.gain.value = 1;
    if (this.buffer) {
      source.buffer = this.buffer;
      amplifier.connect(audioContext.destination);
      source.connect(amplifier);
      source.start(0);
    }
  }
}

export default NnAudioElement;
